import { Input as AntdInput } from 'antd'
import styled from '@emotion/styled'
import { SearchOutlined } from '@ant-design/icons'

export const SearchInput = styled(AntdInput)`
  width: 320px;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  margin-bottom: 24px;
`

export const SearchIcon = styled(SearchOutlined)`
  color: #adadad;
`

// Wrap AntD Table to: (1) hide expand toggles, (2) draw simple tree lines
export const TableWrapper = styled.div`
  /* Hide expand icon column and the icon itself */
  .ant-table-row-expand-icon-cell,
  .ant-table-row-expand-icon {
    display: none !important;
  }

  /* Remove default indent placeholder so we can control spacing */
  .ant-table-row-indent {
    display: none !important;
  }

  /*
    Tree-line styling for nested rows in the Interest code column (2nd column)
    We draw vertical connector lines and a horizontal elbow using layered backgrounds.
    Indent unit is 28px. Line x positions are 14px, 42px, 70px, ...
  */
  /* Level 1 */
  .ant-table .ant-table-tbody > tr.ant-table-row-level-1 td:nth-child(2) {
    position: relative;
    padding-left: 28px;
    background:
      /* vertical at current level */
      linear-gradient(#e5e5e5, #e5e5e5) left 14px top / 1px 100% no-repeat,
      /* horizontal elbow */
      linear-gradient(#e5e5e5, #e5e5e5) left 14px top 50% / 12px 1px no-repeat;
  }

  /* Level 2 */
  .ant-table .ant-table-tbody > tr.ant-table-row-level-2 td:nth-child(2) {
    position: relative;
    padding-left: 56px;
    background:
      /* ancestor vertical at level 1 */
      linear-gradient(#e5e5e5, #e5e5e5) left 14px top / 1px 100% no-repeat,
      /* vertical at current level */
      linear-gradient(#e5e5e5, #e5e5e5) left 42px top / 1px 100% no-repeat,
      /* horizontal elbow for current level */
      linear-gradient(#e5e5e5, #e5e5e5) left 42px top 50% / 12px 1px no-repeat;
  }

  /* Level 3 */
  .ant-table .ant-table-tbody > tr.ant-table-row-level-3 td:nth-child(2) {
    position: relative;
    padding-left: 84px;
    background:
      /* ancestor verticals */
      linear-gradient(#e5e5e5, #e5e5e5) left 14px top / 1px 100% no-repeat,
      linear-gradient(#e5e5e5, #e5e5e5) left 42px top / 1px 100% no-repeat,
      /* vertical at current level */
      linear-gradient(#e5e5e5, #e5e5e5) left 70px top / 1px 100% no-repeat,
      /* horizontal elbow for current level */
      linear-gradient(#e5e5e5, #e5e5e5) left 70px top 50% / 12px 1px no-repeat;
  }
`
